import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import axios from 'axios';

const BASE_URL = (() => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001/api';
  }
  return 'https://factutracks.com/api';
})();

const RenovarSuscripcion = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // 'seleccion' → 'pago'
  const [paso, setPaso] = useState('seleccion');
  const [planes, setPlanes] = useState([]);
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [loadingPlanes, setLoadingPlanes] = useState(true);
  const [preparando, setPreparando] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  const [errorInit, setErrorInit] = useState(null);

  // Cargar planes disponibles (excluir Trial)
  useEffect(() => {
    const fetchPlanes = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/planes`);
        const disponibles = data.filter(p => p.nombre !== 'Trial' && (p.activo === 1 || p.activo === true));
        setPlanes(disponibles);
        if (disponibles.length > 0) setPlanSeleccionado(disponibles[0]);
      } catch {
        setErrorInit('Error al cargar los planes disponibles. Intenta nuevamente.');
      } finally {
        setLoadingPlanes(false);
      }
    };
    fetchPlanes();
  }, []);

  // Ir al pago con el plan elegido
  const handleContinuarPago = async () => {
    if (!planSeleccionado) return;
    setPreparando(true);
    try {
      const { data } = await api.post('/payments/prepare-renewal', { planId: planSeleccionado.id });
      setTransactionId(data.transactionId);
      setPaso('pago');
    } catch {
      toast.error('No se pudo iniciar el proceso de pago. Intenta nuevamente.');
    } finally {
      setPreparando(false);
    }
  };

  // Cargar Payphone cuando tengamos transactionId
  useEffect(() => {
    if (paso !== 'pago' || !transactionId || !planSeleccionado) return;
    loadPayphoneResources();
  }, [paso, transactionId, planSeleccionado]);

  const loadPayphoneResources = () => {
    if (!document.querySelector('#payphone-css')) {
      const link = document.createElement('link');
      link.id = 'payphone-css';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.css';
      document.head.appendChild(link);
    }
    if (!document.querySelector('#payphone-script')) {
      const script = document.createElement('script');
      script.id = 'payphone-script';
      script.src = 'https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.js';
      script.type = 'module';
      script.async = true;
      script.onload = () => renderPayphoneButton();
      script.onerror = () => toast.error('Error al cargar el módulo de pagos. Recarga la página.');
      document.body.appendChild(script);
    } else {
      renderPayphoneButton();
    }
  };

  const renderPayphoneButton = async () => {
    if (!window.PPaymentButtonBox) {
      toast.error('Error al cargar el botón de pagos');
      return;
    }
    try {
      const subtotal = Math.round(planSeleccionado.precio_mensual * 100);
      const { data: config } = await axios.get(`${BASE_URL}/payments/payphone-config`, {
        params: {
          transactionId,
          amount: subtotal,
          plan: planSeleccionado.nombre,
          email: user?.email || '',
        }
      });
      config.responseUrl = `${window.location.origin}/agenda/checkoutconfirm?tipo=renovacion`;
      const payphone = new window.PPaymentButtonBox(config);
      payphone.render('pp-button-renovar');
    } catch {
      toast.error('Error al inicializar el módulo de pagos');
    }
  };

  const s = {
    page: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0f9ff 0%, #ffffff 50%, #eff6ff 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
    },
    card: {
      backgroundColor: 'rgba(255,255,255,0.97)',
      borderRadius: '28px',
      boxShadow: '0 20px 50px -12px rgba(99,102,241,0.25)',
      width: '100%',
      maxWidth: paso === 'seleccion' ? '860px' : '520px',
      padding: '2.5rem',
      position: 'relative',
      overflow: 'hidden',
      transition: 'max-width 0.3s ease',
    },
    bar: {
      position: 'absolute', top: 0, left: 0, right: 0, height: '4px',
      background: 'linear-gradient(90deg, #6366f1, #93c5fd, #6366f1)',
      borderTopLeftRadius: '28px', borderTopRightRadius: '28px'
    },
    badge: {
      display: 'inline-block',
      background: '#f0f0ff',
      border: '1px solid #a5b4fc',
      color: '#4338ca',
      borderRadius: '999px',
      padding: '0.35rem 1rem',
      fontSize: '0.8rem',
      fontWeight: 600,
      marginBottom: '0.75rem'
    },
    title: { fontSize: '1.75rem', fontWeight: '800', color: '#111827', marginBottom: '0.4rem' },
    subtitle: { color: '#6b7280', fontSize: '0.9rem', marginBottom: '1.75rem' },
    planGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: '1rem',
      marginBottom: '1.75rem'
    },
    planCard: (selected) => ({
      padding: '1.25rem',
      borderRadius: '18px',
      border: selected ? '2px solid #6366f1' : '2px solid #e5e7eb',
      background: selected ? 'rgba(99,102,241,0.05)' : 'white',
      cursor: 'pointer',
      transition: 'all 0.2s',
      position: 'relative',
    }),
    planCheck: {
      position: 'absolute', top: '10px', right: '10px',
      width: '22px', height: '22px',
      background: '#6366f1', borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'white', fontSize: '12px', fontWeight: 700
    },
    planName: { fontSize: '1.05rem', fontWeight: 700, marginBottom: '0.4rem', color: '#111827' },
    planPrice: { fontSize: '1.6rem', fontWeight: '800', color: '#6366f1' },
    planPriceSub: { fontSize: '0.8rem', color: '#6b7280' },
    planDesc: { fontSize: '0.75rem', color: '#6b7280', margin: '0.5rem 0' },
    planFeature: { fontSize: '0.78rem', color: '#374151', lineHeight: 1.7 },
    btnPrimary: {
      width: '100%',
      padding: '0.9rem',
      background: '#6366f1',
      color: 'white',
      border: 'none',
      borderRadius: '14px',
      fontSize: '1rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.2s',
      boxShadow: '0 6px 14px -4px rgba(99,102,241,0.4)',
      marginBottom: '0.75rem',
    },
    btnSecondary: {
      width: '100%',
      padding: '0.75rem',
      background: 'transparent',
      color: '#6b7280',
      border: '1px solid #e5e7eb',
      borderRadius: '14px',
      fontSize: '0.9rem',
      cursor: 'pointer',
    },
    payplanBox: {
      background: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '16px',
      padding: '1.25rem',
      margin: '1.25rem 0',
      textAlign: 'center',
    },
    loadingText: { textAlign: 'center', padding: '2rem', color: '#9ca3af', fontSize: '0.9rem' },
    errorBox: {
      background: '#fee2e2', color: '#991b1b',
      padding: '1rem', borderRadius: '12px', margin: '1rem 0'
    },
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.bar} />

        {/* ── PASO 1: Selección de plan ── */}
        {paso === 'seleccion' && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
              <span style={s.badge}>🚀 Elige tu plan</span>
            </div>
            <h2 style={{ ...s.title, textAlign: 'center' }}>Contrata un plan</h2>
            <p style={{ ...s.subtitle, textAlign: 'center' }}>
              Tu período de prueba terminó. Elige el plan que mejor se adapte a tu negocio.
            </p>

            {errorInit ? (
              <div style={s.errorBox}>
                <p style={{ margin: 0 }}>{errorInit}</p>
                <button onClick={() => window.location.reload()} style={{ ...s.btnSecondary, marginTop: '0.75rem', width: 'auto', padding: '0.5rem 1rem' }}>
                  Reintentar
                </button>
              </div>
            ) : loadingPlanes ? (
              <div style={s.loadingText}>Cargando planes...</div>
            ) : (
              <>
                <div style={s.planGrid}>
                  {planes.map(plan => {
                    const sel = planSeleccionado?.id === plan.id;
                    return (
                      <div key={plan.id} style={s.planCard(sel)} onClick={() => setPlanSeleccionado(plan)}>
                        {sel && <div style={s.planCheck}>✓</div>}
                        <div style={s.planName}>{plan.nombre}</div>
                        <div style={{ marginBottom: '0.5rem' }}>
                          <span style={s.planPrice}>${plan.precio_mensual}</span>
                          <span style={s.planPriceSub}>/mes</span>
                        </div>
                        {plan.descripcion && <p style={s.planDesc}>{plan.descripcion}</p>}
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                          <li style={s.planFeature}>✓ {plan.max_usuarios} usuario{plan.max_usuarios > 1 ? 's' : ''}</li>
                          <li style={s.planFeature}>✓ {plan.max_clientes} clientes</li>
                          <li style={s.planFeature}>✓ {plan.max_servicios} servicios</li>
                          {(plan.tiene_sucursales === 1 || plan.tiene_sucursales === true) && (
                            <li style={s.planFeature}>✓ Multi-sucursal</li>
                          )}
                          {(plan.tiene_profesionales === 1 || plan.tiene_profesionales === true) && (
                            <li style={s.planFeature}>✓ Profesionales</li>
                          )}
                          {(plan.tiene_reportes_avanzados === 1 || plan.tiene_reportes_avanzados === true) && (
                            <li style={s.planFeature}>✓ Reportes avanzados</li>
                          )}
                        </ul>
                      </div>
                    );
                  })}
                </div>

                <button
                  style={{ ...s.btnPrimary, opacity: preparando || !planSeleccionado ? 0.7 : 1, cursor: preparando || !planSeleccionado ? 'not-allowed' : 'pointer' }}
                  onClick={handleContinuarPago}
                  disabled={preparando || !planSeleccionado}
                >
                  {preparando ? 'Preparando pago...' : `Continuar con ${planSeleccionado?.nombre || '—'} → $${planSeleccionado?.precio_mensual || '0'}/mes`}
                </button>
              </>
            )}

            <button style={s.btnSecondary} onClick={() => navigate('/')}>
              ← Volver al inicio
            </button>
          </>
        )}

        {/* ── PASO 2: Pago ── */}
        {paso === 'pago' && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
              <span style={s.badge}>💳 Pago seguro</span>
            </div>
            <h2 style={{ ...s.title, textAlign: 'center' }}>Completar pago</h2>
            <p style={{ ...s.subtitle, textAlign: 'center' }}>
              Estás contratando el plan <strong>{planSeleccionado?.nombre}</strong>
            </p>

            <div style={s.payplanBox}>
              <p style={{ margin: '0 0 0.25rem', color: '#6b7280', fontSize: '0.85rem' }}>Plan seleccionado</p>
              <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.35rem', color: '#111827' }}>
                {planSeleccionado?.nombre}
              </h3>
              <div>
                <span style={{ fontSize: '2rem', fontWeight: '800', color: '#6366f1' }}>${planSeleccionado?.precio_mensual}</span>
                <span style={{ color: '#6b7280' }}>/mes</span>
              </div>
              <p style={{ margin: '0.5rem 0 0', fontSize: '0.8rem', color: '#9ca3af' }}>{user?.email}</p>
            </div>

            <div id="pp-button-renovar" style={{ minHeight: '200px' }}>
              {!transactionId && <div style={s.loadingText}>Preparando módulo de pagos...</div>}
            </div>

            <button
              style={{ ...s.btnSecondary, marginTop: '0.75rem' }}
              onClick={() => { setPaso('seleccion'); setTransactionId(null); }}
            >
              ← Cambiar plan
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default RenovarSuscripcion;
